<template>
  <v-card class="ma-2">
    <v-card-actions v-if="presentMode && showActions">
      <v-btn flat icon small @click="$emit('delete')">
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn flat icon small @click="showForm">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-title class="justify-center">
      <v-avatar
          :size="170"
      >
        <img v-if="presentMode" :src="obj.image.url || require('../assets/chess-knight.svg')" :alt="obj.image.name">
        <img v-else :src="form.image.url || require('../assets/chess-knight.svg')" :alt="form.image.name">
      </v-avatar>
      <image-input
          v-if="!presentMode"
          accept="image/*"
          @file-update="updateImage"
          :no-title-update="true"
          :show-remove="!!form.image.name"
          round
          flat
          small></image-input>
    </v-card-title>
    <v-card-text>
      <v-layout class="justify-center" v-if="presentMode">{{obj.name}}&nbsp;<span v-if="hasProbability"> - {{obj.probability}}%</span>
      </v-layout>
      <v-form v-else v-model="valid" ref="contestantsCardForm" @submit="addCard" onSubmit="return false">
        <v-text-field
            v-model="form.name"
            label="Name"
            :rules="[v => !!v || 'required']"
            required
            autofocus
            ref="formName"
        ></v-text-field>
        <v-text-field
            v-if="hasProbability"
            v-model.number="form.probability"
            label="Probability"
            suffix="%"
            type="number"
            :rules="[v => !hasProbability || !!v || 'required',
                     v => v>=0  && v<=100 || 'probability must be between 0 and 100']"
            required
        ></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="add" :disabled="!valid" depressed round color="success" type="submit">add</v-btn>
          <v-btn v-if="isEditing" @click="isEditing = false" small flat round color="grey">cancel</v-btn>
          <v-btn v-if="isEditing" @click="editCard" :disabled="!valid" small depressed round color="success">edit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
    import ImageInput from "@/components/ImageInput";

    export default {
        name: "ContestantsCard",
        components: {ImageInput},
        props: {
            obj: {
                default: () => ({
                    image: {
                        name: '',
                        url: '',
                        file: ''
                    },
                    name: '',
                    probability: '',
                })
            },
            add: {
                default: false,
                type: Boolean
            },
            hasProbability: {
                default: true,
                type: Boolean
            },
            showActions: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                valid: false,
                form: {
                    image: {
                        name: this.obj.image.name,
                        url: this.obj.image.url,
                        file: this.obj.image.file
                    },
                    name: this.obj.name,
                    probability: this.obj.probability,
                },
                isEditing: false,
            }
        },
        computed: {
            presentMode: function () {
                return !this.add && !this.isEditing
            },
        },
        methods: {
            addCard: function () {
                let obj = this.cloneForm()
                this.$emit('add-card', obj)
                this.$refs.contestantsCardForm.reset()
                this.$refs.formName.focus()
                this.initForm()
            },
            cloneForm: function () {
                const obj = {
                    image: {
                        name: this.form.image.name,
                        url: this.form.image.url,
                        file: this.form.image.file
                    },
                    name: this.form.name,
                    probability: this.form.probability,
                }
                return obj
            },
            initForm: function () {
                this.form.image.name = this.obj.image.name
                this.form.image.url = this.obj.image.url
                this.form.image.file = this.obj.image.file
                this.form.name = this.obj.name
                this.form.probability = this.obj.probability
            },
            showForm: function () {
                this.initForm()
                this.isEditing = true
            },
            editCard: function () {
                const obj = {i: '', card: ''}
                obj.card = this.cloneForm()
                this.$emit('edit', obj)
                this.isEditing = false
            },
            updateImage: function (file) {
                if (file) {
                    this.form.image.file = file // this file can be sent to server...
                    this.form.image.name = file.name
                    const fr = new FileReader()
                    fr.readAsDataURL(file)
                    fr.addEventListener('load', () => {
                        this.form.image.url = fr.result
                    })
                } else {
                    this.form.image.url = ''
                    this.form.image.name = ''
                    this.form.image.file = ''
                }
            }
        },
    }
</script>

<style scoped>

</style>
